module.exports = __webpack_public_path__ + "static/media/VEG-BASIS.7ec6f91d.png";